export default "__VITE_ASSET__BQnk55w4__"